export const getIsLoggedIn = ({ state }) => state.app.isLoggedIn;
export const getDecodedToken = ({ state }) => state.app.decodedToken;
export const getIsLoaderOpen = ({ state }) => state.app.isLoaderOpen;
export const getPermissionsList = ({ state }) => state.app.permissions;
export const getConnectionStatus = ({ state }) => state.app.connectionStatus;
export const getSliderImg = ({ state }) => state.app.sliderImg;
export const getCountriesListData = ({ state }) => state.app.countriesListData;
export const getIsLoggedoutClicked = ({ state }) => state.app.isLoggedoutClicked;
